export default {
    "name": "UpdateSettingValue",
    "kind": "HoudiniMutation",
    "hash": "9d9d80e1dd4167e7a44ce8d8c90d3c75b5b4e35ca418d118592c14cfb2dc510f",

    "raw": `mutation UpdateSettingValue($input: SettingsValueUpdate!) {
  updateSettingValue(input: $input)
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateSettingValue": {
                "type": "Boolean",
                "keyRaw": "updateSettingValue(input: $input)",
                "nullable": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "SettingsValueUpdate"
        },

        "types": {
            "SettingShape": {
                "settingId": "UInt",
                "value": "String"
            },

            "SettingsValueUpdate": {
                "settings": "SettingShape"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=6ebac329d980a9c3559c527764ba6838d42ebd521b34e0bddbfe4dd3b04b985f";